import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSidebarSimpleRightWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconSidebarSimpleRightWide"><Path fillRule="evenodd" clipRule="evenodd" d="M15 5.5V18.5H3.75C3.61193 18.5 3.5 18.3881 3.5 18.25V5.75C3.5 5.61193 3.61193 5.5 3.75 5.5H15ZM22 5.75C22 4.7835 21.2165 4 20.25 4H3.75C2.7835 4 2 4.7835 2 5.75V18.25C2 19.2165 2.7835 20 3.75 20H20.25C21.2165 20 22 19.2165 22 18.25V5.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSidebarSimpleRightWide;
